import type { JSX } from 'react';

import { Helmet } from 'react-helmet-async';

import { InfoSection } from '../components/InfoSection';
import { RecipientSection } from '../components/RecipientSection';
import { TitleSection } from '../components/TitleSection';

export function RacialJusticeFund(): JSX.Element {
	return (
		<>
			<Helmet>
				<title>Change.org Racial Justice Fund</title>
				<meta name="description" content="Change.org Racial Justice Fund" />
				<meta property="og:title" content="Change.org Racial Justice Fund" />
				<meta property="og:description" content="Change.org Racial Justice Fund" />
			</Helmet>
			<TitleSection />
			<InfoSection />
			<RecipientSection />
		</>
	);
}
